// Generated by CoffeeScript 1.12.7
(function () {
  var FeatureFlag, ProjectStore;

  require("Dashboard/DashboardState.ng.html");

  ProjectStore = require("Project/Stores/ProjectStore")["default"];

  FeatureFlag = require("@CommonFrontendBackend/FeatureFlag").FeatureFlag;

  module.exports = angular
    .module("qwilr.dashboard", ["ui.router"])
    .config(function ($stateProvider, $urlRouterProvider) {
      $urlRouterProvider.otherwise("/pages");
      return $stateProvider
        .state("dashboard", {
          url: "/{nav:pages|blocks|reports|templates|engagement-library|automations}",
          params: {
            nav: "pages",
            squash: true,
            savedBlockParams: {},
          },
          templateUrl: "Dashboard/DashboardState.ng.html",
          controller: function ($scope, $rootScope, $stateParams) {
            var di;
            di = $rootScope.di.child();
            return di.invoke(function (projectLiveLimit, initSubscription, stringManipulater, isMobile, $state) {
              if (($stateParams != null ? $stateParams.nav : void 0) === "blocks" && isMobile()) {
                return $state.go("dashboard", {
                  nav: "pages",
                });
              }
              $scope.ui = {
                dashboard: di.invoke(require("./DashboardMount")["default"]),
                showLiveLimitMessage: function () {
                  return projectLiveLimit.getOverLimitAmount() > 0;
                },
                liveLimitPhrase: function () {
                  return stringManipulater.pluralise(projectLiveLimit.getOverLimitAmount, "project");
                },
                explorePlans: function () {
                  return initSubscription.init();
                },
              };
            });
          },
        })
        .state("dashboardProjectAction", {
          url: "/pages/:action/:projectId",
          templateUrl: "Dashboard/DashboardState.ng.html",
          controller: function ($rootScope, $stateParams) {
            return $rootScope.di.invoke(function (
              projectService,
              loadingIndicator,
              state,
              projectApiService,
              pageResourceApiService,
              projectTelemetry,
              user,
              rootDataStore,
              genericHost,
            ) {
              return projectService.getProject($stateParams.projectId).then(function (project) {
                var projectStore, ref;
                projectStore = new ProjectStore(
                  project,
                  projectApiService,
                  pageResourceApiService,
                  user,
                  projectTelemetry,
                  rootDataStore,
                  genericHost,
                );
                loadingIndicator.hide();
                if ((ref = $stateParams.action) === "share" || ref === "pdf" || ref === "analytics") {
                  return state.goToProjectAction($stateParams.action, projectStore, "dashboard");
                } else {
                  return $state.go("dashboard", {
                    nav: "pages",
                  });
                }
              });
            });
          },
        })
        .state("dashboardOld", {
          url: "/projects",
          templateUrl: "Dashboard/DashboardState.ng.html",
          controller: function ($location) {
            return $location.path("/pages");
          },
        })
        .state("dashboardProjectActionOld", {
          url: "/projects/:action/:projectId",
          templateUrl: "Dashboard/DashboardState.ng.html",
          controller: function ($location, $stateParams) {
            return $location.path("/pages/" + $stateParams.action + "/" + $stateParams.projectId);
          },
        });
    });
}.call(this));
